export default "__VITE_ASSET__O106_eoV__"